const IS_LOADING = "user/IS_LOADING";
const IS_ERROR = "user/IS_ERROR";
const LOGIN_USER = "user/LOGIN_USER";
const LOGOUT_USER = "user/LOGOUT_USER";

export { IS_LOADING, IS_ERROR, LOGIN_USER, LOGOUT_USER };
